import { render, staticRenderFns } from "./ResetPasswordView.vue?vue&type=template&id=4abf3507&scoped=true&lang=html&"
import script from "./ResetPasswordView.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abf3507",
  null
  
)

export default component.exports